import script from "./ScriptGeneratorView.vue?vue&type=script&setup=true&lang=js"
export * from "./ScriptGeneratorView.vue?vue&type=script&setup=true&lang=js"

import "./ScriptGeneratorView.vue?vue&type=style&index=0&id=757ab11c&lang=scss"

const __exports__ = script;

export default __exports__